var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M23 0C10.31 0 0 10.31 0 23C0 35.68 10.31 46 23 46C35.68 46 46 35.68 46 23C46 10.31 35.68 0 23 0ZM31.71 30.29C32.09 30.67 32.09 31.32 31.71 31.71C31.5 31.9 31.25 32 31 32C30.74 32 30.49 31.9 30.28 31.71L23 24.41L15.71 31.71C15.5 31.9 15.25 32 15 32C14.74 32 14.49 31.9 14.28 31.71C13.9 31.32 13.9 30.67 14.28 30.29L21.58 23L14.28 15.71C13.9 15.32 13.9 14.67 14.28 14.29C14.67 13.9 15.32 13.9 15.71 14.29L23 21.58L30.28 14.29C30.67 13.9 31.32 13.9 31.71 14.29C32.09 14.67 32.09 15.32 31.71 15.71L24.41 23L31.71 30.29Z",
    fill: "#031634",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.fdd89b026c8de7a0d49739337380e3b1.svg";
export { ForwardRef as ReactComponent };